const DEVICE_UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isUuidDeviceLabel(name: string | null | undefined): boolean {
  const n = String(name || '').trim();
  if (!n) return false;
  const stripped = n.replace(/^uuid:/i, '');
  return DEVICE_UUID_RE.test(n) || DEVICE_UUID_RE.test(stripped);
}

export function zoneProfileDisplayLabel(profile?: {
  display_name?: string | null;
  discovered_name?: string | null;
} | null): string {
  return String(profile?.display_name || profile?.discovered_name || '').trim();
}

function usableNetworkLabel(label: string, zoneId: string): boolean {
  const n = String(label || '').trim();
  if (!n) return false;
  if (zoneId && n === zoneId) return false;
  return !isUuidDeviceLabel(n);
}

/** Friendly name for UPnP/RAAT zones whose `.name` is a raw device UUID. */
export function networkZoneDisplayName(
  zone: {
    name?: string;
    metadata?: { model?: string; manufacturer?: string };
  } | null | undefined,
  zoneId: string,
  t: (key: string) => string,
): string {
  const name = String(zone?.name || '').trim();
  if (usableNetworkLabel(name, zoneId)) return name;
  const model = String(zone?.metadata?.model || '').trim();
  const manufacturer = String(zone?.metadata?.manufacturer || '').trim();
  if (usableNetworkLabel(model, zoneId)) {
    if (manufacturer && !model.toLowerCase().startsWith(manufacturer.toLowerCase())) {
      return `${manufacturer} ${model}`.trim();
    }
    return model;
  }
  if (usableNetworkLabel(manufacturer, zoneId)) return manufacturer;
  return 'Network player';
}
